import * as actionTypes from './GoalsTypes';

const INITIAL_STATE = {
    goalsList: [],
    goalsHeaderCount: [],
    goalDetails: {},
    completedTasksByEmployee: [],
};

const GoalsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_GOALS_LIST:
            return {
                ...state,
                goalsList: action.payload.list,
            };
        case actionTypes.SET_GOALS_HEADER_COUNT:
            return {
                ...state,
                goalsHeaderCount: action.payload.list,
            };
        case actionTypes.SET_GOAL_DETAILS:
            return {
                ...state,
                goalDetails: action.payload.details,
            };
        case actionTypes.SET_COMPLETED_TASKS_BY_EMPLOYEE:
            return {
                ...state,
                completedTasksByEmployee: action.payload.list,
            };
        case actionTypes.CLEAR_GOALS_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default GoalsReducer;